export var ChartPatternAuditBatchStatus;
(function (ChartPatternAuditBatchStatus) {
    ChartPatternAuditBatchStatus["active"] = "active";
    ChartPatternAuditBatchStatus["archived"] = "archived";
})(ChartPatternAuditBatchStatus || (ChartPatternAuditBatchStatus = {}));
export var ChartPatternAuditSelectionStrategy;
(function (ChartPatternAuditSelectionStrategy) {
    ChartPatternAuditSelectionStrategy["selectedCurrent"] = "selectedCurrent";
    ChartPatternAuditSelectionStrategy["allCurrent"] = "allCurrent";
})(ChartPatternAuditSelectionStrategy || (ChartPatternAuditSelectionStrategy = {}));
export var ChartPatternAuditReviewerType;
(function (ChartPatternAuditReviewerType) {
    ChartPatternAuditReviewerType["human"] = "human";
    ChartPatternAuditReviewerType["ai"] = "ai";
})(ChartPatternAuditReviewerType || (ChartPatternAuditReviewerType = {}));
export var ChartPatternAuditRenderStatus;
(function (ChartPatternAuditRenderStatus) {
    ChartPatternAuditRenderStatus["pending"] = "pending";
    ChartPatternAuditRenderStatus["rendering"] = "rendering";
    ChartPatternAuditRenderStatus["rendered"] = "rendered";
    ChartPatternAuditRenderStatus["failed"] = "failed";
})(ChartPatternAuditRenderStatus || (ChartPatternAuditRenderStatus = {}));
export var ChartPatternAuditArtifactType;
(function (ChartPatternAuditArtifactType) {
    ChartPatternAuditArtifactType["rawWide"] = "rawWide";
    ChartPatternAuditArtifactType["rawFocused"] = "rawFocused";
    ChartPatternAuditArtifactType["annotatedWide"] = "annotatedWide";
    ChartPatternAuditArtifactType["annotatedFocused"] = "annotatedFocused";
})(ChartPatternAuditArtifactType || (ChartPatternAuditArtifactType = {}));
export var ChartPatternAuditArtifactStorageProvider;
(function (ChartPatternAuditArtifactStorageProvider) {
    ChartPatternAuditArtifactStorageProvider["localDisk"] = "localDisk";
})(ChartPatternAuditArtifactStorageProvider || (ChartPatternAuditArtifactStorageProvider = {}));
export var ChartPatternAuditAiAgreementVerdict;
(function (ChartPatternAuditAiAgreementVerdict) {
    ChartPatternAuditAiAgreementVerdict["agree"] = "agree";
    ChartPatternAuditAiAgreementVerdict["disagree"] = "disagree";
    ChartPatternAuditAiAgreementVerdict["uncertain"] = "uncertain";
})(ChartPatternAuditAiAgreementVerdict || (ChartPatternAuditAiAgreementVerdict = {}));
export var ChartPatternAuditAiSeverity;
(function (ChartPatternAuditAiSeverity) {
    ChartPatternAuditAiSeverity["low"] = "low";
    ChartPatternAuditAiSeverity["medium"] = "medium";
    ChartPatternAuditAiSeverity["high"] = "high";
})(ChartPatternAuditAiSeverity || (ChartPatternAuditAiSeverity = {}));
export var ChartPatternAuditVerdict;
(function (ChartPatternAuditVerdict) {
    ChartPatternAuditVerdict["correct"] = "correct";
    ChartPatternAuditVerdict["weakButAcceptable"] = "weakButAcceptable";
    ChartPatternAuditVerdict["incorrect"] = "incorrect";
    ChartPatternAuditVerdict["duplicate"] = "duplicate";
    ChartPatternAuditVerdict["uncertain"] = "uncertain";
})(ChartPatternAuditVerdict || (ChartPatternAuditVerdict = {}));
export var ChartPatternAuditReasonCode;
(function (ChartPatternAuditReasonCode) {
    ChartPatternAuditReasonCode["notRounded"] = "notRounded";
    ChartPatternAuditReasonCode["tooVShaped"] = "tooVShaped";
    ChartPatternAuditReasonCode["handleTooDeep"] = "handleTooDeep";
    ChartPatternAuditReasonCode["handleTooLong"] = "handleTooLong";
    ChartPatternAuditReasonCode["handleTooLow"] = "handleTooLow";
    ChartPatternAuditReasonCode["badRimSymmetry"] = "badRimSymmetry";
    ChartPatternAuditReasonCode["weakImpulseLeg"] = "weakImpulseLeg";
    ChartPatternAuditReasonCode["poleTooLong"] = "poleTooLong";
    ChartPatternAuditReasonCode["flagTooFlat"] = "flagTooFlat";
    ChartPatternAuditReasonCode["flagTooDeep"] = "flagTooDeep";
    ChartPatternAuditReasonCode["flagTooWide"] = "flagTooWide";
    ChartPatternAuditReasonCode["poorChannelStructure"] = "poorChannelStructure";
    ChartPatternAuditReasonCode["poorTriangleStructure"] = "poorTriangleStructure";
    ChartPatternAuditReasonCode["weakPriorTrend"] = "weakPriorTrend";
    ChartPatternAuditReasonCode["upperBoundaryWrongSlope"] = "upperBoundaryWrongSlope";
    ChartPatternAuditReasonCode["lowerBoundaryWrongSlope"] = "lowerBoundaryWrongSlope";
    ChartPatternAuditReasonCode["weakBoundaryTouches"] = "weakBoundaryTouches";
    ChartPatternAuditReasonCode["poorCompression"] = "poorCompression";
    ChartPatternAuditReasonCode["poorTrendlineFit"] = "poorTrendlineFit";
    ChartPatternAuditReasonCode["apexTooLate"] = "apexTooLate";
    ChartPatternAuditReasonCode["badBreakout"] = "badBreakout";
    ChartPatternAuditReasonCode["stale"] = "stale";
    ChartPatternAuditReasonCode["duplicate"] = "duplicate";
    ChartPatternAuditReasonCode["windowWrong"] = "windowWrong";
    ChartPatternAuditReasonCode["wrongLifecycleState"] = "wrongLifecycleState";
    ChartPatternAuditReasonCode["other"] = "other";
})(ChartPatternAuditReasonCode || (ChartPatternAuditReasonCode = {}));
//# sourceMappingURL=ChartPatternAuditTypes.js.map